import * as angular from "angular";
import {IController} from "angular";
import {ExpensesCategory} from "../../models/expenses-category.model";

export class ExpensesCategoriesTableRowComponent implements IController {
  category: ExpensesCategory;
  onArchive: Function;
  onEdit: Function;

  constructor() {
  }

  $onInit() {
  }
}

angular
  .module('bringoz.admin.expenses')
  .component('expensesCategoriesTableRow', {
    bindings: {
      category: '<',
      onEdit: '&',
      onArchive: '&'
    },
    template: require('./expenses-categories-table-row.html').default,
    controller: ExpensesCategoriesTableRowComponent
  });

